export const STORE_DEFAULT_NAME = '__STATE_MACHINE__';
export const STORE_ACTION_NAME = '__STATE_MACHINE_ACTION_NAME__';
export const STATE_MACHINE_DEBUG_NAME = '___STATE_MACHINE_DEBUG__';
export const STATE_MACHINE_DEV_TOOL_CONFIG = '___STATE_MACHINE_DEV_CONFIG__';

export const COLORS = {
  primary: '#0a1c2c',
  secondary: 'rgb(17, 50, 76)',
};

export const Z_INDEX = {
  top: 99999998,
  second: 99999999,
};
